import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d3879a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "call-message" }
const _hoisted_2 = { class: "left" }

import ChatMessageContent from "@/components/chat/chatContainer/ChatMessageContent/ChatMessageContent.vue";
import { CallMessage, Message } from "@/store/chats/types";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { getCallStatusProperties } from "@/utils/message";
import Icon from "@/components/icons/Icon/Icon.vue";

interface ChatMessageProps {
  message: CallMessage;
  index: number;
  visibleMessages: Message[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatCallMessage',
  props: {
    message: {},
    index: {},
    visibleMessages: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();
const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const isOutgoing = computed(() => authId.value === props.message.senderId);
const statusProperties = computed(() =>
  getCallStatusProperties({
    isOutgoing: isOutgoing.value,
    status: props.message.status,
    duration: props.message.duration,
  }),
);
const text = computed(
  () => t(statusProperties.value.text) + statusProperties.value.duration,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatMessageContent, {
    index: _ctx.index,
    message: _ctx.message,
    "visible-messages": _ctx.visibleMessages
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Icon, {
            icon: statusProperties.value.arrowIcon,
            class: "arrow"
          }, null, 8, ["icon"]),
          _createElementVNode("span", {
            class: _normalizeClass(["call-message-text", [{ incoming: !isOutgoing.value }, _ctx.message.status]])
          }, _toDisplayString(text.value), 3)
        ])
      ])
    ]),
    _: 1
  }, 8, ["index", "message", "visible-messages"]))
}
}

})